export type NavItem = {
  label: string
  href: string
  children?: NavItem[]
}

export type GeneralSettingTranslatable = {
  header_nav_items: NavItem[]
  header_cta_label: string
  footer_eyebrow: string
  footer_title: string
  footer_description: string
  footer_tagline: string
}

export type GeneralSettingSection = {
  translations: Record<string, GeneralSettingTranslatable>
  header_logo1_url: string | null
  header_logo2_url: string | null
  header_cta_href: string
  footer_phone1: string
  footer_phone2: string
  footer_email: string
  footer_address: string
  footer_telegram_url: string
  footer_facebook_url: string
  footer_tiktok_url: string
  footer_copyright_text: string
  footer_powered_by: string
  is_active: boolean
}

export const DEFAULT_LANGUAGE_CODE = "km"

export const EMPTY_GENERAL_SETTING_TRANSLATION: GeneralSettingTranslatable = {
  header_nav_items: [],
  header_cta_label: "",
  footer_eyebrow: "",
  footer_title: "",
  footer_description: "",
  footer_tagline: "",
}

export const GENERAL_SETTING_DEFAULTS: GeneralSettingSection = {
  translations: {
    km: {
      header_nav_items: [
        { label: "ទំព័រដើម", href: "#top" },
        { label: "យុទ្ធនាការ", href: "#campaign" },
        { label: "សកម្មភាព", href: "#activities" },
        { label: "ដៃគូសហការ", href: "#partners" },
        { label: "វាគ្មិនចូលរួម", href: "#coaches" },
        {
          label: "ការជូនដំណឹង",
          href: "/invitation-announcement",
          children: [
            { label: "សេចក្តីប្រកាសអញ្ជើញ", href: "/invitation-announcement" },
            { label: "សេចក្តីណែនាំ", href: "/instructions-participants" },
            { label: "សេចក្តីជូនដំណឹង", href: "/notice-announcement" },
          ],
        },
      ],
      header_cta_label: "ចុះឈ្មោះឥឡូវនេះ",
      footer_eyebrow: "Cambodia Food Expo",
      footer_title: "ពិព័រណ៍ពាណិជ្ជកម្ម និងទីផ្សារអាហារកម្ពុជា ឆ្នាំ២០២៦",
      footer_description:
        "ប្រសិនបើអ្នកត្រូវការព័ត៌មានបន្ថែមអំពីការចូលរួម ការកក់ Booth ឬការឧបត្ថម្ភ សូមទាក់ទងក្រុមការងារតាមបណ្តាញខាងក្រោម។",
      footer_tagline: "Empowering Cambodian Food Businesses • Connecting Markets • Inspiring Innovation",
    },
    en: {
      header_nav_items: [
        { label: "Home", href: "#top" },
        { label: "Campaign", href: "#campaign" },
        { label: "Activities", href: "#activities" },
        { label: "Partners", href: "#partners" },
        { label: "Speakers", href: "#coaches" },
        {
          label: "Announcements",
          href: "/invitation-announcement",
          children: [
            { label: "Invitation Announcement", href: "/invitation-announcement" },
            { label: "Instructions for Participants", href: "/instructions-participants" },
            { label: "Notice Announcement", href: "/notice-announcement" },
          ],
        },
      ],
      header_cta_label: "Register Now",
      footer_eyebrow: "Cambodia Food Expo",
      footer_title: "Cambodia Food Trade & Marketing Expo 2026",
      footer_description:
        "If you need more information about participating, booking a booth, or sponsorship, please contact our team through the channels below.",
      footer_tagline: "Empowering Cambodian Food Businesses • Connecting Markets • Inspiring Innovation",
    },
  },
  header_logo1_url: "/images/cam-food-expo/khmerstrong.png",
  header_logo2_url: "/images/cam-food-expo/logo/new%20logo%2004.png",
  header_cta_href: "https://t.me/ceomasterofficer",
  footer_phone1: "023 6666 999",
  footer_phone2: "061 424 265",
  footer_email: "info@msme-expo.com",
  footer_address: "Diamond Twin Tower, ជាន់ទី 7M, បន្ទប់ S7M02-A, ផ្លូវសុភមង្គល, ភូមិ 14, សង្កាត់ទន្លេបាសាក់, ខណ្ឌចំការមន, រាជធានីភ្នំពេញ",
  footer_telegram_url: "https://t.me/ceomasterofficer",
  footer_facebook_url: "https://www.facebook.com/khfoodsector",
  footer_tiktok_url: "https://www.tiktok.com/@khmerfoodexpo2026?is_from_webapp=1&sender_device=pc",
  footer_copyright_text: "© 2026 Cambodia Food Expo. All Rights Reserved.",
  footer_powered_by: "Powered by CEO Institute | CEO Master Club",
  is_active: true,
}

export function getGeneralSettingTranslation(
  data: { translations?: GeneralSettingSection["translations"] | null } | null | undefined,
  languageCode: string
): GeneralSettingTranslatable {
  const translations = data?.translations ?? GENERAL_SETTING_DEFAULTS.translations
  const entry = translations[languageCode] ?? translations[DEFAULT_LANGUAGE_CODE]
    ?? GENERAL_SETTING_DEFAULTS.translations[languageCode]
    ?? GENERAL_SETTING_DEFAULTS.translations[DEFAULT_LANGUAGE_CODE]
  return { ...EMPTY_GENERAL_SETTING_TRANSLATION, ...entry }
}
